import { Button } from '@chakra-ui/react'
import { RefObject } from 'react'

import { ACTIONS, ActionKind } from './actions'

export interface IFormActionsProps {
  onCancel: () => void
  /** Omitido quando o botão de confirmação é o submit de um `<form>`. */
  onConfirm?: () => void
  /** Define cor e rótulo do botão de confirmação. `delete` para diálogos de exclusão. */
  confirmAction?: ActionKind
  confirmLabel?: string
  cancelLabel?: string
  isLoading?: boolean
  isDisabled?: boolean
  /** Usado como `leastDestructiveRef` em `AlertDialog`. */
  cancelRef?: RefObject<HTMLButtonElement>
  confirmType?: 'button' | 'submit'
}

/**
 * Par Cancelar + Confirmar para rodapés de modal e AlertDialog.
 * Ordem, variantes e rótulos são fixos para todo o painel.
 */
export default function FormActions({
  onCancel,
  onConfirm,
  confirmAction = 'save',
  confirmLabel,
  cancelLabel = 'Cancelar',
  isLoading = false,
  isDisabled = false,
  cancelRef,
  confirmType = 'button'
}: IFormActionsProps) {
  const config = ACTIONS[confirmAction]

  return (
    <>
      <Button ref={cancelRef} variant="ghost" onClick={onCancel} isDisabled={isLoading}>
        {cancelLabel}
      </Button>
      <Button
        colorScheme={config.colorScheme}
        type={confirmType}
        onClick={onConfirm}
        isLoading={isLoading}
        isDisabled={isDisabled}
        ml={3}
      >
        {confirmLabel ?? config.label}
      </Button>
    </>
  )
}
